module.exports = __webpack_public_path__ + "img/money.68e75c37.svg";